import { Text } from '@dixa/lib-shared-habla';

import { AppLink } from 'components/appLink';

import { EndpointMessengers } from '../customForms.types';

type Props = {
  endpointMessengers: EndpointMessengers;
  onLinkClick: () => void;
};

export function EndpointMessengersDisplay({
  endpointMessengers,
  onLinkClick,
}: Props): JSX.Element {
  const { endpoint, messengersInfo } = endpointMessengers;
  return (
    <div>
      <Text.Paragraph>
        Form&apos;s endpoint &quot;{endpoint.description}&quot; is currently
        utilized by messengers:
      </Text.Paragraph>
      <ul>
        {messengersInfo.map(({ messengerId, messengerName }) => (
          <li key={messengerId}>
            <AppLink
              path="/settings/dixa-messenger/settings/:messengerId"
              params={{ path: { messengerId } }}
              onClick={onLinkClick}
            >
              {messengerName}
            </AppLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
